import APIService from '@/services/api.service';
import { Store } from '@/store.js';
import Q from 'q';

class UserService {

    constructor() {}

    get isAuthenticated() {
        return this.get()
            .then( () => true )
            .catch( () => false );
    }

    authenticate(username, password) {
        var settings = APIService.defaultSettingsPlus({
            'url': APIService.baseURL + '/api/v1/login',
            'method': 'POST',
            'headers': {
                'authorization': 'Basic ' + btoa(username + ':' + password)
            }
        });
        return APIService.waitFor( Q($.ajax(settings)) )
            .then(this.storeUserLocally);
    }

    forgotPassword(username) {
        var settings = APIService.defaultSettingsPlus({
            url: APIService.baseURL + '/api/v1/forgot-password',
            method: 'POST',
            data: {
                email: username,
                resetUrl: window.location.origin + '/#/password-reset/?token={token}&username='+encodeURIComponent(username)
            }
        });
        return APIService.waitFor( Q($.ajax(settings)) );
    }

    resetPassword(username, password, token, isNewAccount) {
        var settings = APIService.defaultSettingsPlus({
            url: APIService.baseURL + '/api/v1/reset-password',
            method: 'POST',
            data: {
                email: username,
                newPassword: password
            }
        });
        // We pass a different parameter to hold the token depending on whether this is first-time account setup vs a simple password-reset
        var tokenName = isNewAccount ? 'invitationToken' : 'passwordResetToken';
        settings.data[tokenName] = token;
        return APIService.waitFor( Q($.ajax(settings)) );
    }

    requestVerificationEmail() {
        return this.get()
            .then(sendVerificationFor);

        function sendVerificationFor(user) {
            var settings = APIService.defaultSettingsPlus({
                url: APIService.baseURL + '/api/v1/users/' + user.id + '/request-verification',
                method: 'POST',
                data: {
                    email: user.email,
                    resetUrl: window.location.origin + '/#/verify/?token={token}&username='+encodeURIComponent(user.email)+'&id='+user.id
                }
            });
            return APIService.waitFor( Q($.ajax(settings)) );
        }
    }

    verifyToken(token) {
        return this.get()
            .then(sendTokenFor);

        function sendTokenFor(user) {
            var settings = APIService.defaultSettingsPlus({
                url: APIService.baseURL + '/api/v1/users/'+user.id+'/verify-account',
                method: 'POST',
                data: {
                    email: user.email,
                    verificationToken: token
                }
            });
            return APIService.waitFor( Q($.ajax(settings)) );
        }

    }

    get() {
        if ( Store.data.user && Store.data.user.id ) return Q.when(Store.data.user);
        return this.hydrate();
    }

    hydrate() {
        var id = localStorage.getItem('UserId');
        var apiKey = localStorage.getItem('UserApiKey');
        if ( !(id && apiKey) ) return Q.reject( { message : 'No saved API key.' } );

        APIService.apiKey = apiKey;
        var settings = APIService.defaultSettingsPlus({
            'url': APIService.baseURL + '/api/v1/users/' + id
        });

        return APIService.waitFor( Q($.ajax(settings)), true )
            .then(this.storeUserLocally);
    }

    storeUserLocally(data) {
        var user = data.entity;
        Store.data.user = user;
        if (user.apiKey) {
            APIService.apiKey = data.entity.apiKey;
            localStorage.setItem('UserApiKey',data.entity.apiKey);
            localStorage.setItem('UserId',data.entity.id);
        }
        return user;
    }

    logout() {
        return this.get()
            .then(this.requestLogout)
            .catch(this.clearUser);
    }

    requestLogout(user) {
        var settings = APIService.defaultSettingsPlus({
            'url': APIService.baseURL + '/api/v1/logout',
            'method': 'POST'
        });
        return APIService.waitFor( Q($.ajax(settings)) )
            .then(this.clearUser);
    }

    clearUser(data) {
        Store.destroy();
        APIService.apiKey = undefined;
        localStorage.removeItem('UserApiKey');
        localStorage.removeItem('UserId');
        return data;
    }

    updateUser(user) {
        var userData = {
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName
        };
        if (user.password) userData.password = user.password;
        var settings = APIService.defaultSettingsPlus({
            url: APIService.baseURL + '/api/v1/users/' + user.id,
            method: 'PUT',
            data: {
                user: userData
            }
        });
        return APIService.waitFor( Q($.ajax(settings)) )
            .then( updateStoredUser );

        function updateStoredUser() {
            $.extend(Store.data.user, user);
        }
    }
}

export default new UserService();


// WEBPACK FOOTER //
// ./src/services/user.service.js